import { useMemo } from "react";

import { ExerciseResults } from "features";
import { ExerciseModals } from "features/ExerciseModals/ExerciseModals";

import { useAppSelector } from "store/hooks";
import { getAssignments, getResults, getNewEnvelopes } from "store/slices/exercise";
import type { IAssignmentResult, IOption } from "store/slices/exercise";

interface IEnvelopesChange {
  newEnvelope: string;
  oldEnvelope: string;
}

interface IData {
  data: Record<string, IAssignmentResult<IOption | string>>;
  envelopes: Record<string, IEnvelopesChange>;
}

const Results = () => {
  const results = useAppSelector(getResults);
  const assignments = useAppSelector(getAssignments);
  const newEnvelopes = useAppSelector(getNewEnvelopes);

  // AIDEV-NOTE: musí být useMemo, ne useState+useEffect — první render ExerciseResults už potřebuje data,
  // protože neřízený Tab.Container si výchozí záložku vezme z prvního renderu a později ji nezmění. [TD-471]
  const transformedData = useMemo<IData>(() => {
    const data: Record<string, IAssignmentResult<IOption | string>> = {};
    const envelopes: Record<string, IEnvelopesChange> = {};

    for (const assignment of assignments) {
      const assignmentId = assignment.id;

      data[assignmentId] = results[assignmentId];

      envelopes[assignmentId] = { newEnvelope: newEnvelopes[assignmentId], oldEnvelope: assignment.envelope ?? "" };
    }

    return { data, envelopes };
  }, [results, assignments, newEnvelopes]);

  return (
    <>
      <ExerciseResults results={transformedData.data} envelopes={transformedData.envelopes} />
      <ExerciseModals />
    </>
  );
};

export default Results;
